import { http } from '../request'
import type {
    AdminAccountListRequest,
    AdminAccountListResponse,
    AdminAccountDetailResponse,
    AccountBanResponse,
    AccountRestoreResponse,
    AccountUnbanResponse,
    AccountStatisticsResponse
} from '../types_admin/accounts'

/**
 * 管理员账号管理 API
 */
export const adminAccountsApi = {
    /**
     * 获取账号列表
     * GET /api/admin/accounts/accounts/
     */
    getAccountList(params?: AdminAccountListRequest): Promise<AdminAccountListResponse> {
        return http.list('/api/admin/accounts/accounts/', params)
    },

    /**
     * 获取账号详情
     * GET /api/admin/accounts/accounts/{id}/
     */
    getAccountDetail(id: number): Promise<AdminAccountDetailResponse> {
        return http.get(`/api/admin/accounts/accounts/${id}/`)
    },

    /**
     * 审核通过
     * POST /api/admin/audit/{id}/approve/
     */
    approveAccount(id: number): Promise<void> {
        return http.post(`/api/admin/audit/${id}/approve/`)
    },

    /**
     * 审核拒绝
     * POST /api/admin/audit/{id}/reject/
     */
    rejectAccount(id: number, data: { reason: string }): Promise<void> {
        return http.post(`/api/admin/audit/${id}/reject/`, data)
    },

    /**
     * 封禁账号
     * POST /api/admin/accounts/accounts/{id}/ban/
     */
    banAccount(id: number): Promise<AccountBanResponse> {
        return http.post(`/api/admin/accounts/accounts/${id}/ban/`)
    },

    /**
     * 恢复账号
     * POST /api/admin/accounts/accounts/{id}/restore/
     */
    restoreAccount(id: number): Promise<AccountRestoreResponse> {
        return http.post(`/api/admin/accounts/accounts/${id}/restore/`)
    },

    /**
     * 解封账号
     * POST /api/admin/accounts/accounts/{id}/unban/
     */
    unbanAccount(id: number): Promise<AccountUnbanResponse> {
        return http.post(`/api/admin/accounts/accounts/${id}/unban/`)
    },

    /**
     * 强制删除账号
     * POST /api/admin/accounts/accounts/{id}/force-delete/
     */
    forceDeleteAccount(id: number): Promise<void> {
        return http.post(`/api/admin/accounts/accounts/${id}/force-delete/`)
    },

    /**
     * 获取审核统计数据（审计模块）
     * GET /api/admin/audit/statistics/
     */
    getAccountStatistics(): Promise<AccountStatisticsResponse> {
        return http.get('/api/admin/audit/statistics/')
    },
    /**
     * 管理员下架账号
     * POST /api/admin/accounts/accounts/{id}/unpublish/
     */
    unpublishAccount(id: number): Promise<void> {
        return http.post(`/api/admin/accounts/accounts/${id}/unpublish/`)
    },
    /**
     * 获取账号管理统计（各状态数量）
     * GET /api/admin/accounts/accounts/management-statistics/
     */
    getManagementStatistics(): Promise<Record<string, number>> {
        return http.get('/api/admin/accounts/accounts/management-statistics/')
    },

    /**
     * 设置押金减免
     * POST /api/admin/accounts/accounts/{id}/set-deposit-reduction/
     */
    setDepositReduction(id: number, data: { reduction_amount: number; reason: string }): Promise<AdminAccountDetailResponse> {
        return http.post(`/api/admin/accounts/accounts/${id}/set-deposit-reduction/`, data)
    },

    /**
     * 设置租金折扣
     * POST /api/admin/accounts/accounts/{id}/set-rental-discount/
     */
    setRentalDiscount(id: number, data: { discount_percent: number; reason: string }): Promise<AdminAccountDetailResponse> {
        return http.post(`/api/admin/accounts/accounts/${id}/set-rental-discount/`, data)
    },

    /**
     * 清除管理员调整
     * POST /api/admin/accounts/accounts/{id}/clear-adjustments/
     */
    clearAdjustments(id: number): Promise<AdminAccountDetailResponse> {
        return http.post(`/api/admin/accounts/accounts/${id}/clear-adjustments/`)
    }
} 